var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl_avatar",class:{ round: _vm.round },style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    borderRadius: _vm.radius,
  })},[_c('img',{staticClass:"cl_avatar_img",attrs:{"src":_vm.src || require('@i/common/default_avatar.svg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }